// extracted by mini-css-extract-plugin
export default {"entry":"ExitReasonEntry_entry__q+n0u","link":"ExitReasonEntry_link__z8LK2"};